import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';

import CaregiverForm from '../../../../components/Manage/CaregiverForm';

import IconPlus from 'cccisd-icons/plus-circle2';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;
let currentRole = Fortress.user && Fortress.user.acting.role.handle;

const AddCaregiverForm = props => {
    const modal = useRef();

    const onSubmit = async values => {
        const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
            role: 'caregiver',
            firstName: values.firstName,
            lastName: values.lastName,
            wrapId: values.wrapId,
            phoneNumber: values.phoneNumber,
            language: values.language,
            youth: values.youth,
            childPawns: JSON.stringify(values.youth),
            parentPawns: JSON.stringify(values.careCoordinator),
            careCoordinator: values.careCoordinator,
            group: values.site,
            receiveMessages: values.receiveMessages,
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ message: errorMessage, type: 'danger' });
            return Promise.reject(response.data.errors);
        }

        await props.loadData();
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <span>
                        <IconPlus spaceRight />
                        Add Caregiver
                    </span>
                </button>
            }
            title="Add New Caregiver"
        >
            <CaregiverForm
                onSubmit={onSubmit}
                initialValues={{
                    site:
                        currentRole === 'careCoordinator' || currentRole === 'supervisor'
                            ? [Fortress.user.acting.group_id]
                            : [],
                    careCoordinator: currentRole === 'careCoordinator' ? [Fortress.user.acting.id] : [],
                    youth: [],
                    receiveMessages: true,
                }}
            />
        </Modal>
    );
};

export default AddCaregiverForm;
